import { Fragment, useEffect } from "react";
import { FormEntry, FormTextArea } from "components";
import { useFieldArray } from "react-hook-form";

export const SecondPage = ({
	register,
	errors,
	control,
	watch,
	studentPrefix,
	student,
	setStudentPrefix,
}) => {
	useEffect(() => {
		setStudentPrefix(studentPrefix);
	}, []);

	const { fields: studentTraits } = useFieldArray({
		control,
		name: `studentReport.${studentPrefix}.traits`,
	});

	return (
		<>
			<small className="text-light ml-2 mb-4">
				*If score is rated less than 2.5, an additional comment is
				required to justify the given rating.
			</small>
			<input
				type="hidden"
				{...register(`studentReport.${studentPrefix}.studentId`, {
					value: student.studentDetail?.id,
				})}
			/>
			{studentTraits.map((trait, index) => (
				<Fragment key={trait.id}>
					<FormEntry
						register={register}
						prefix={"studentReport." + studentPrefix}
						formLabel={trait.name}
						type="number"
						name={`traits.${index}.performance`}
						required={true}
						placeholder="Score (0-5)"
						validation={{
							validate: {
								checkLessThan5Morethan0: (value) =>
									(value <= 5 && value >= 0) ||
									"Value must be between 0 and 5",
							},
						}}
						error={
							errors.studentReport?.[studentPrefix]?.traits?.[
								index
							]?.performance
						}
					/>
					{watch(
						`studentReport.${studentPrefix}.traits.${index}.performance`
					) < 2.5 && (
						<FormTextArea
							register={register}
							prefix={"studentReport." + studentPrefix}
							formLabel={trait.name + " Comments"}
							placeholder={`${trait.name} additional comment`}
							name={`traits.${index}.comments`}
							required={true}
							error={
								errors.studentReport?.[studentPrefix]?.traits[
									index
								]?.comments
							}
						/>
					)}
				</Fragment>
			))}
		</>
	);
};
